import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import '../styles/Login.css';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    const result = await login(email, password);

    if (result.success) {
      navigate('/');
    } else {
      setError(result.error);
    }

    setIsLoading(false);
  };

  return (
    <div className="login-container">
      <div className="login-content">
        <div className="logo-section">
          <img
            src="/assets/showcase_transparent.png"
            // src="/assets/showcase-backgronud.jpg"
            alt="Showcase Architects Logo"
            className="login-logo"
          />
        </div>

        <div className="login-box">
          <h1>Showcase eTime Login</h1>
          <br></br>
          {/* <h2>Login</h2> */}

          <form onSubmit={handleSubmit}>
            {error && (
              <div className="error-message">
                {typeof error === 'string' ? error : error.message || 'Login failed'}
              </div>
            )}

            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                placeholder="Enter your email"
              />
            </div>

            <div className="form-group">
              <label htmlFor="password">Password</label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                placeholder="Enter your password"
              />
            </div>

            <button type="submit" disabled={isLoading} className="btn btn-primary">
              {isLoading ? 'Logging in...' : 'Login'}
            </button>
          </form>

          <div className="demo-credentials">
            <p>Found a bug or have login issues?</p>
            <small>Contact: helpdesk@showcasearchitects.com</small>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
